var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.editfield.enable_calculation
    ? _c("div", { staticClass: "contactum-calculation-options" }, [
        _c("label", [_vm._v("Expression Builder ")]),
        _vm._v(" "),
        _c("div", { staticClass: "contactum" }, [
          _c("div", { staticClass: "contactum_calculation_buttons" }, [
            _c(
              "div",
              { staticClass: "contactum_calculation_fields" },
              [
                _c("merge_tags", {
                  attrs: {
                    calculate: true,
                    fieldsonly: true,
                    formFields: _vm.calculableFields
                  },
                  on: { insert: _vm.insertOperand }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "textarea",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formula_field,
                expression: "formula_field"
              }
            ],
            staticStyle: { width: "100%", height: "60px" },
            attrs: { id: "contactum_calculation_formula_field" },
            domProps: { value: _vm.formula_field },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.formula_field = $event.target.value
              }
            }
          },
          [_vm._v(_vm._s(_vm.formula_field))]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.validateExpression($event)
              }
            }
          },
          [_vm._v(" Validate Expression ")]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }